<template>
    <header :class="!$page.props.isProductionEnvironment ? 'non-production' : 'production'">
        <DBreadcrumbs
            :breadcrumbs="breadcrumbs"
            class="breadcrumbs"
        />
        <slot />
    </header>
</template>

<script>
import DBreadcrumbs from './DBreadcrumbs'
export default {
    name: 'AppHeader',
    components: { DBreadcrumbs },
    props: {
        breadcrumbs: {
            type: Array,
            default: () => { return [] }
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    height: 60px;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    padding: 0px 25px;
    align-items: center;
    z-index: 1000;
    border-bottom: 1px solid rgba(0,0,0,0.07);

    & .title {
        font-size: 18px;
    }
    & .breadcrumbs {
        margin-top: 0.9em;
        font-size: 16px;
    }
}
</style>
